<div class="d-flex flex-column-fluid flex-center mt-30 mt-lg-0">
  <!--begin::Signin-->
  <div class="login-form login-signin">
    <div class="mt-5 mb-15 d-flex justify-content-center text-align-center">
      <a class="flex-column-auto mt-5">
        <img style="opacity: 0.77" src="./assets/media/logos/aplosLogo.png" class="max-h-70px" />
      </a>
    </div>
    <div class="text-center mb-10 mb-lg-20">
      <h3 class="font-size-h1">{{ 'AUTH.LOGIN.BUTTON' | translate }}</h3>
      <p class="text-muted font-weight-bold">
        {{
          firstSubmit
            ? ('AUTH.LOGIN.ENTER_EMAIL' | translate)
            : ('AUTH.LOGIN.ENTER_PASS' | translate)
        }}
      </p>
    </div>

    <kt-auth-notice></kt-auth-notice>
    <div *ngIf="!firstSubmit">
      <button type="button" class="btn btn-link" (click)="changeEmail()">
        <i class="ki ki-long-arrow-back icon-sm text-muted" style="font-size: 1rem !important"></i
        >Change email
      </button>
    </div>

    <!--begin::Form-->
    <form
      class="form"
      [formGroup]="loginForm"
      autocomplete="off"
      novalidate="novalidate"
      id="kt_login_form"
    >
      <div class="form-group">
        <mat-form-field
          class="mat-form-field-background-grey"
          floatLabel="always"
          [style.display]="enterEmail ? 'block' : 'none'"
        >
          <input
            matInput
            type="text"
            placeholder="{{ 'AUTH.INPUT.EMAIL_USERNAME' | translate }}"
            formControlName="email"
            autocomplete="off"
          />
          <mat-error *ngIf="isControlHasError('email', 'required')">
            <strong>{{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}</strong>
          </mat-error>
          <mat-error *ngIf="isControlHasError('email', 'minlength')">
            <strong>{{ 'AUTH.VALIDATION.MIN_LENGTH_FIELD' | translate }} 3</strong>
          </mat-error>
          <mat-error *ngIf="isControlHasError('email', 'maxlength')">
            <strong>{{ 'AUTH.VALIDATION.MAX_LENGTH_FIELD' | translate }} 320</strong>
          </mat-error>
        </mat-form-field>
      </div>
      <div class="form-group password-statment" *ngIf="!workOSExist">
        <mat-form-field class="mat-form-field-background-grey" floatLabel="always">
          <input
            matInput
            placeholder="{{ 'AUTH.INPUT.PASSWORD' | translate }}"
            formControlName="password"
            [type]="!hide ? 'password' : 'text'"
            autocomplete="off"
            #passwordField
          />

          <mat-icon matSuffix (click)="hide = !hide">{{
            hide ? 'visibility' : 'visibility_off'
          }}</mat-icon>

          <mat-error *ngIf="isControlHasError('password', 'required')">
            <strong>{{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}</strong>
          </mat-error>
          <mat-error *ngIf="isControlHasError('password', 'minlength')">
            <strong>{{ 'AUTH.VALIDATION.MIN_LENGTH_FIELD' | translate }} 8</strong>
          </mat-error>
          <mat-error *ngIf="isControlHasError('password', 'maxlength')">
            <strong>{{ 'AUTH.VALIDATION.MAX_LENGTH_FIELD' | translate }} 100</strong>
          </mat-error>
          <mat-error *ngIf="isControlHasError('password', 'pattern')">
            <strong>{{ 'AUTH.VALIDATION.PATTERN_PASSWORD' | translate }} </strong>
          </mat-error>
        </mat-form-field>
      </div>
      <!--begin::Action-->
      <div class="form-group forget-statment" *ngIf="!workOSExist">
        <a
          href="javascript:;"
          routerLink="/auth/forgot-password"
          class="text-dark-50 text-hover-primary my-3 mr-2"
          id="kt_login_forgot"
          >{{ 'AUTH.GENERAL.FORGOT_BUTTON' | translate }} ?</a
        >
      </div>

      <div class="text-center mt-5">
        <button
          id="kt_login_signin_submit"
          (click)="submit()"
          [ngClass]="{ 'spinner spinner-right spinner-md spinner-light': loading }"
          class="btn btn-info btn-pill shadow-sm py-4 px-9 font-weight-bold"
        >
          Sign In
        </button>
      </div>

      <!--end::Action-->
    </form>
    <!--end::Form-->
  </div>
  <!--end::Signin-->
</div>
